import type {ReactElement} from 'react';
import React from 'react';

import {AnimationType} from '@PosterWhiteboard/items/item/item.types';

export const NONE_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      className="intro-animation-svg"
      d="M24.2531 46.2679C36.3929 46.2679 46.2342 36.4266 46.2342 24.2868C46.2342 12.1469 36.3929 2.30566 24.2531 2.30566C12.1133 2.30566 2.27197 12.1469 2.27197 24.2868C2.27197 36.4266 12.1133 46.2679 24.2531 46.2679Z"
      stroke="#403F5D"
      strokeWidth="3.31918"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line className="intro-animation-svg" x1="7.81348" y1="9.52184" x2="40.399" y2="38.5035" stroke="#403F5D" strokeWidth="3.32354" />
  </svg>
);

export const BLOCK_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      className="intro-animation-svg"
      d="M40.9151 76.945C61.2486 76.945 77.7321 60.4615 77.7321 40.128C77.7321 19.7946 61.2486 3.31104 40.9151 3.31104C20.5817 3.31104 4.09814 19.7946 4.09814 40.128C4.09814 60.4615 20.5817 76.945 40.9151 76.945Z"
      stroke="#403F5D"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect clipPath="url(#clip-block)" className="intro-animation-svg block-animation" x="0.133789" y="0.0786133" width="81.0495" height="80.0985" fill="url(#paint0_linear)" />
    <defs>
      <clipPath id="clip-block">
        <rect x="0.474548" y="0.551514" width="81.0495" height="79.1419" />
      </clipPath>
      <linearGradient id="paint0_linear" x1="0.133789" y1="40.1279" x2="40.9151" y2="40.1279" gradientUnits="userSpaceOnUse">
        <stop stopColor="#403F5D" />
        <stop offset="1" stopColor="#403F5D" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const BOUNCE_IN_DOWN_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      className="hide-on-animation-start intro-animation-svg bounce-in-down-animation"
      d="M32.7642 75.795C47.7792 75.795 59.9512 63.623 59.9512 48.6081C59.9512 33.5932 47.7792 21.4211 32.7642 21.4211C17.7493 21.4211 5.57727 33.5932 5.57727 48.6081C5.57727 63.623 17.7493 75.795 32.7642 75.795Z"
      stroke="#403F5D"
      opacity="0.4"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="hide-on-animation-start intro-animation-svg"
      d="M49.8249 92.0587C64.8398 92.0587 77.0118 79.8867 77.0118 64.8718C77.0118 49.8568 64.8398 37.6848 49.8249 37.6848C34.81 37.6848 22.6379 49.8568 22.6379 64.8718C22.6379 79.8867 34.81 92.0587 49.8249 92.0587Z"
      fill="#ffffff"
      stroke="#403F5D"
      opacity="0.7"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="hide-on-animation-start intro-animation-svg"
      d="M67.7053 61.0519C82.7202 61.0519 94.8922 48.8799 94.8922 33.8649C94.8922 18.85 82.7202 6.67798 67.7053 6.67798C52.6903 6.67798 40.5183 18.85 40.5183 33.8649C40.5183 48.8799 52.6903 61.0519 67.7053 61.0519Z"
      fill="#ffffff"
      stroke="#403F5D"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FADE_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.2531 45.7528C36.3929 45.7528 46.2342 35.9115 46.2342 23.7716C46.2342 11.6318 36.3929 1.79053 24.2531 1.79053C12.1133 1.79053 2.27197 11.6318 2.27197 23.7716C2.27197 35.9115 12.1133 45.7528 24.2531 45.7528Z"
      className="hide-on-animation-start intro-animation-svg"
      stroke="#403F5D"
      strokeWidth="3.31918"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.2532 42.399C34.5407 42.399 42.8805 34.0593 42.8805 23.7717C42.8805 13.4841 34.5407 5.14441 24.2532 5.14441C13.9656 5.14441 5.62585 13.4841 5.62585 23.7717C5.62585 34.0593 13.9656 42.399 24.2532 42.399Z"
      className="hide-on-animation-start intro-animation-svg fade-animation transform-origin-center"
      opacity="0.4"
      stroke="#403F5D"
      strokeWidth="3.31918"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const JELLO_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 90 89" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M39.9645 72.2191C55.3327 72.2191 74.7911 59.7607 74.7911 44.3925C74.7911 29.0243 55.3327 16.5659 39.9645 16.5659C24.5963 16.5659 46.9645 29.0243 46.9645 44.3925C46.9645 59.7607 24.5963 72.2191 39.9645 72.2191Z"
      className="hide-on-animation-start intro-animation-svg"
      opacity="0.4"
      stroke="#403F5D"
      strokeWidth="6.22619"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.9646 85.6252C67.7367 85.6252 86.1972 67.1647 86.1972 44.3925C86.1972 21.6204 67.7367 3.15991 44.9646 3.15991C22.1924 3.15991 3.73193 21.6204 3.73193 44.3925C3.73193 67.1647 22.1924 85.6252 44.9646 85.6252Z"
      className="intro-animation-svg jello-animation"
      origin="center"
      stroke="#403F5D"
      strokeWidth="6.22619"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const POP_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M44.9646 86.0434C67.7367 86.0434 86.1972 67.5829 86.1972 44.8108C86.1972 22.0386 67.7367 3.57812 44.9646 3.57812C22.1924 3.57812 3.73193 22.0386 3.73193 44.8108C3.73193 67.5829 22.1924 86.0434 44.9646 86.0434Z"
      className="hide-on-animation-start intro-animation-svg pop-animation transform-origin-center"
      stroke="#403F5D"
      strokeWidth="6.22619"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.9646 67.6296C48.5671 67.6296 58.7835 57.4133 58.7835 44.8108C58.7835 32.2083 48.5671 21.9919 35.9646 21.9919C23.3621 21.9919 13.1458 32.2083 13.1458 44.8108C13.1458 57.4133 23.3621 67.6296 35.9646 67.6296Z"
      className="hide-on-animation-start intro-animation-svg"
      opacity="0.4"
      stroke="#403F5D"
      strokeWidth="6.22619"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PAN_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 100 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M37.9016 82.184C19.7532 82.184 5.04095 67.4718 5.04095 49.3233C5.04095 31.1749 19.7532 16.4626 37.9016 16.4626C56.0501 16.4626 70.7623 31.1749 70.7623 49.3233C70.7623 67.4718 56.0501 82.184 37.9016 82.184Z"
      className="hide-on-animation-start intro-animation-svg pan-animation"
      stroke="#403F5D"
      opacity="0.4"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.3146 82.184C44.1661 82.184 29.4539 67.4718 29.4539 49.3233C29.4539 31.1749 44.1661 16.4626 62.3146 16.4626C80.4631 16.4626 95.1753 31.1749 95.1753 49.3233C95.1753 67.4718 80.4631 82.184 62.3146 82.184Z"
      className="hide-on-animation-start intro-animation-svg"
      fill="white"
      stroke="#403F5D"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ROTATE_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 83 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M41.4442 80.0048C20.4547 80.0048 3.43933 62.9894 3.43933 41.9999C3.43933 21.0105 20.4547 3.99512 41.4442 3.99512"
      className="hide-on-animation-start intro-animation-svg origin-center"
      origin="center"
      stroke="url(#rotate-default-paint-1)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
    />
    <path
      d="M41.4393 80.0048C62.4288 80.0048 79.4441 62.9894 79.4441 41.9999C79.4441 21.0105 62.4288 3.99512 41.4393 3.99512"
      className="hide-on-animation-start intro-animation-svg origin-center"
      origin="center"
      stroke="url(#rotate-default-paint-2)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
    />
    <path
      d="M42.0024 80.0372C21.0129 80.0372 3.99756 63.0219 3.99756 42.0324C3.99756 21.0429 21.0129 4.02759 42.0024 4.02759"
      className="hide-on-animation-start rotate-animation origin-center"
      origin="center"
      opacity="0"
      stroke="url(#rotate-hover-paint-1)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
    />
    <path
      d="M41.9975 80.0372C62.987 80.0372 80.0023 63.0219 80.0023 42.0324C80.0023 21.0429 62.987 4.02759 41.9975 4.02759"
      className="hide-on-animation-start rotate-animation origin-center"
      origin="center"
      opacity="0"
      stroke="url(#rotate-hover-paint-2)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
    />
    <defs>
      <linearGradient id="rotate-default-paint-1" x1="41.4442" y1="3.99512" x2="41.4442" y2="80.0048" gradientUnits="userSpaceOnUse">
        <stop stopColor="#A0A0A0" />
        <stop offset="1" stopColor="#403F5D" />
      </linearGradient>
      <linearGradient id="rotate-default-paint-2" x1="41.4393" y1="3.99512" x2="41.4393" y2="80.0048" gradientUnits="userSpaceOnUse">
        <stop stopColor="#A0A0A0" />
        <stop offset="1" stopColor="#403F5D" stopOpacity="0" />
      </linearGradient>

      <linearGradient className="rotate-color" id="rotate-hover-paint-1" x1="42.0024" y1="4.02759" x2="42.0024" y2="80.0372" gradientUnits="userSpaceOnUse">
        <stop stopColor="#403F5D" stopOpacity="0.25" />
        <stop offset="1" stopColor="#403F5D" />
      </linearGradient>
      <linearGradient className="rotate-color" id="rotate-hover-paint-2" x1="41.9975" y1="4.02759" x2="41.9975" y2="80.0372" gradientUnits="userSpaceOnUse">
        <stop stopColor="#403F5D" stopOpacity="0.25" />
        <stop offset="1" stopColor="#403F5D" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const ROTATE_ANIMATION_SVG_SELECTED = (
  <svg width="20" height="20" viewBox="0 0 83 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M41.4442 80.0048C20.4547 80.0048 3.43933 62.9894 3.43933 41.9999C3.43933 21.0105 20.4547 3.99512 41.4442 3.99512"
      className="hide-on-animation-start intro-animation-svg origin-center"
      origin="center"
      stroke="url(#rotate-default-paint-1)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
    />
    <path
      d="M41.4393 80.0048C62.4288 80.0048 79.4441 62.9894 79.4441 41.9999C79.4441 21.0105 62.4288 3.99512 41.4393 3.99512"
      className="hide-on-animation-start intro-animation-svg origin-center"
      origin="center"
      stroke="url(#rotate-default-paint-2)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
    />
    <path
      d="M42.0024 80.0372C21.0129 80.0372 3.99756 63.0219 3.99756 42.0324C3.99756 21.0429 21.0129 4.02759 42.0024 4.02759"
      className="hide-on-animation-start rotate-animation origin-center"
      origin="center"
      opacity="0"
      stroke="url(#rotate-hover-paint-1)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
    />
    <path
      d="M41.9975 80.0372C62.987 80.0372 80.0023 63.0219 80.0023 42.0324C80.0023 21.0429 62.987 4.02759 41.9975 4.02759"
      className="hide-on-animation-start rotate-animation origin-center"
      origin="center"
      opacity="0"
      stroke="url(#rotate-hover-paint-2)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
    />
    <defs>
      <linearGradient id="rotate-default-paint-1" x1="41.4442" y1="3.99512" x2="41.4442" y2="80.0048" gradientUnits="userSpaceOnUse">
        <stop stopColor="#A0A0A0" />
        <stop offset="1" stopColor="#403F5D" />
      </linearGradient>
      <linearGradient id="rotate-default-paint-2" x1="41.4393" y1="3.99512" x2="41.4393" y2="80.0048" gradientUnits="userSpaceOnUse">
        <stop stopColor="#A0A0A0" />
        <stop offset="1" stopColor="#403F5D" stopOpacity="0" />
      </linearGradient>

      <linearGradient className="rotate-color" id="rotate-hover-paint-1" x1="42.0024" y1="4.02759" x2="42.0024" y2="80.0372" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00688C" stopOpacity="0.25" />
        <stop offset="1" stopColor="#00688C" />
      </linearGradient>
      <linearGradient className="rotate-color" id="rotate-hover-paint-2" x1="41.9975" y1="4.02759" x2="41.9975" y2="80.0372" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00688C" stopOpacity="0.25" />
        <stop offset="1" stopColor="#00688C" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const SLIDE_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip-peek-right)">
      <path
        d="M23.8726 82.3952C5.72521 82.203 -8.83043 67.3359 -8.63829 49.1884C-8.44614 31.041 6.42102 16.4853 24.5685 16.6775C42.7159 16.8696 57.2715 31.7368 57.0794 49.8842C56.8873 68.0317 42.0201 82.5873 23.8726 82.3952Z"
        className="hide-on-animation-start intro-animation-svg slide-animation"
        stroke="#403F5D"
        fill="#FFFFFF"
        opacity="0.4"
        strokeWidth="6.18409"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.1882 82.8114C45.0408 82.6193 30.4851 67.7521 30.6773 49.6047C30.8694 31.4572 45.7366 16.9016 63.884 17.0937C82.0315 17.2859 96.5871 32.1531 96.395 50.3005C96.2028 68.4479 81.3356 83.0036 63.1882 82.8114Z"
        className="hide-on-animation-start intro-animation-svg"
        stroke="#403F5D"
        fill="#FFFFFF"
        strokeWidth="6.18409"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="1.409" y1="98.6703" x2="2.44298" y2="1.01427" className="intro-animation-svg" stroke="#403F5D" opacity="0.4" strokeWidth="6.18409" />
    </g>
    <defs>
      <clipPath id="clip-peek-right">
        <rect width="98" height="98" fill="white" transform="matrix(-0.999944 -0.0105873 -0.0105873 0.999944 100.017 1.73364)" />
      </clipPath>
    </defs>
  </svg>
);

export const TUMBLE_ANIMATION_SVG = (
  <svg className="svg-medium" width="20" height="20" viewBox="0 0 83 83" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M55.2253 30.5597C41.8479 30.5597 31.0034 41.4042 31.0034 54.7816C31.0034 68.1589 41.8479 79.0034 55.2253 79.0034"
      className="hide-on-animation-start intro-animation-svg"
      stroke="url(#tumble-default-component-1-paint-1)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
    />
    <path
      d="M55.2222 30.5599C68.5996 30.5599 79.4441 41.4044 79.4441 54.7818C79.4441 68.1592 68.5996 79.0037 55.2222 79.0037"
      className="hide-on-animation-start intro-animation-svg"
      stroke="url(#tumble-default-component-1-paint-2)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
    />
    <path
      d="M16.7571 30.3238C24.1671 30.3238 30.1741 24.3169 30.1741 16.9069C30.1741 9.49695 24.1671 3.48999 16.7571 3.48999"
      className="hide-on-animation-start intro-animation-svg"
      stroke="url(#tumble-default-component-2-paint-1)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
    />
    <path
      d="M16.7588 30.3236C9.34888 30.3236 3.34192 24.3166 3.34192 16.9067C3.34192 9.49671 9.34888 3.48975 16.7588 3.48975"
      className="hide-on-animation-start intro-animation-svg"
      stroke="url(#tumble-default-component-2-paint-2)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
    />

    <path
      d="M16.7571 30.3238C24.1671 30.3238 30.1741 24.3169 30.1741 16.9069C30.1741 9.49695 24.1671 3.48999 16.7571 3.48999"
      className="hide-on-animation-start intro-animation-svg tumble-animation origin-center"
      opacity="0"
      stroke="url(#tumble-hover-component-2-paint-1)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
      origin="center"
    />
    <path
      d="M16.7588 30.3236C9.34888 30.3236 3.34192 24.3166 3.34192 16.9067C3.34192 9.49671 9.34888 3.48975 16.7588 3.48975"
      className="hide-on-animation-start intro-animation-svg tumble-animation origin-center"
      opacity="0"
      stroke="url(#tumble-hover-component-2-paint-2)"
      strokeWidth="6.22619"
      strokeLinejoin="bevel"
      origin="center"
    />

    <defs>
      <linearGradient id="tumble-default-component-1-paint-1" x1="55.2253" y1="79.0034" x2="55.2253" y2="30.5597" gradientUnits="userSpaceOnUse">
        <stop stopColor="#A0A0A0" />
        <stop offset="1" stopColor="#403F5D" />
      </linearGradient>
      <linearGradient id="tumble-default-component-1-paint-2" x1="55.2222" y1="79.0037" x2="55.2222" y2="30.5599" gradientUnits="userSpaceOnUse">
        <stop stopColor="#A0A0A0" />
        <stop offset="1" stopColor="#403F5D" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="tumble-default-component-2-paint-1" x1="16.7571" y1="3.48999" x2="16.7571" y2="30.3238" gradientUnits="userSpaceOnUse">
        <stop stopColor="#A0A0A0" />
        <stop offset="1" stopColor="#403F5D" />
      </linearGradient>
      <linearGradient id="tumble-default-component-2-paint-2" x1="16.7588" y1="3.48975" x2="16.7588" y2="30.3236" gradientUnits="userSpaceOnUse">
        <stop stopColor="#A0A0A0" />
        <stop offset="1" stopColor="#403F5D" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="tumble-hover-component-2-paint-1" x1="17.5136" y1="3.94458" x2="17.5136" y2="30.7784" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0.75" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient id="tumble-hover-component-2-paint-2" x1="17.5153" y1="3.94434" x2="17.5153" y2="30.7782" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0.75" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const RISE_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.7584 61.4332C16.7584 79.5817 31.4707 94.2939 49.6191 94.2939C67.7676 94.2939 82.4798 79.5817 82.4798 61.4332C82.4798 43.2847 67.7676 28.5725 49.6191 28.5725C31.4707 28.5725 16.7584 43.2847 16.7584 61.4332Z"
      className="hide-on-animation-start intro-animation-svg rise-animation"
      stroke="#403F5D"
      opacity="0.4"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.7584 37.0204C16.7584 55.1688 31.4707 69.881 49.6191 69.881C67.7676 69.881 82.4798 55.1688 82.4798 37.0204C82.4798 18.8719 67.7676 4.15967 49.6191 4.15967C31.4707 4.15967 16.7584 18.8719 16.7584 37.0204Z"
      className="hide-on-animation-start intro-animation-svg"
      fill="white"
      stroke="#403F5D"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SHRINK_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.2531 45.7528C36.3929 45.7528 46.2342 35.9115 46.2342 23.7716C46.2342 11.6318 36.3929 1.79053 24.2531 1.79053C12.1133 1.79053 2.27197 11.6318 2.27197 23.7716C2.27197 35.9115 12.1133 45.7528 24.2531 45.7528Z"
      className="hide-on-animation-start intro-animation-svg shrink-animation transform-origin-center"
      // transform-origin="center"
      opacity="0.4"
      stroke="#403F5D"
      strokeWidth="3.31918"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.2532 36.4131C31.2348 36.4131 36.8946 30.7534 36.8946 23.7717C36.8946 16.7901 31.2348 11.1304 24.2532 11.1304C17.2716 11.1304 11.6118 16.7901 11.6118 23.7717C11.6118 30.7534 17.2716 36.4131 24.2532 36.4131Z"
      className="hide-on-animation-start intro-animation-svg"
      stroke="#403F5D"
      strokeWidth="3.31918"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PEEK_DOWN_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip-peek-down)">
      <path
        d="M16.8967 23.3227C16.8967 5.17421 31.6089 -9.53802 49.7574 -9.53802C67.9058 -9.53802 82.618 5.17421 82.618 23.3227C82.618 41.4711 67.9058 56.1833 49.7574 56.1833C31.6089 56.1833 16.8967 41.4711 16.8967 23.3227Z"
        className="hide-on-animation-start intro-animation-svg peek-down-animation"
        stroke="#403F5D"
        opacity="0.4"
        strokeWidth="6.18409"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8967 62.6405C16.8967 44.4921 31.6089 29.7798 49.7574 29.7798C67.9058 29.7798 82.618 44.4921 82.618 62.6405C82.618 80.789 67.9058 95.5012 49.7574 95.5012C31.6089 95.5012 16.8967 80.789 16.8967 62.6405Z"
        className="hide-on-animation-start intro-animation-svg"
        stroke="#403F5D"
        strokeWidth="6.18409"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="0.384705" y1="1.03254" x2="98.0462" y2="1.03255" className="intro-animation-svg" stroke="#403F5D" opacity="0.4" strokeWidth="6.18409" />
    </g>
    <defs>
      <clipPath id="clip-peek-down">
        <rect width="98.2891" height="98.2891" fill="white" transform="matrix(0 -1 -1 0 98.3599 98.6091)" />
      </clipPath>
    </defs>
  </svg>
);

export const PEEK_UP_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip-peek-up)">
      <path
        d="M82.5215 76.214C82.5622 94.3625 67.8829 109.108 49.7345 109.148C31.5861 109.189 16.8409 94.5095 16.8003 76.3611C16.7597 58.2127 31.439 43.4676 49.5874 43.427C67.7358 43.3864 82.4809 58.0656 82.5215 76.214Z"
        className="hide-on-animation-start intro-animation-svg peek-up-animation"
        stroke="#403F5D"
        opacity="0.4"
        strokeWidth="6.18409"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M82.4336 36.8964C82.4742 55.0448 67.7949 69.7899 49.6465 69.8305C31.4981 69.8712 16.753 55.1919 16.7124 37.0435C16.6718 18.8951 31.351 4.14994 49.4995 4.10933C67.6479 4.06873 82.393 18.748 82.4336 36.8964Z"
        className="hide-on-animation-start  intro-animation-svg"
        stroke="#403F5D"
        strokeWidth="6.18409"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="99.0834" y1="98.4672" x2="1.42211" y2="98.6857" className=" intro-animation-svg" stroke="#403F5D" opacity="0.4" strokeWidth="6.18409" />
    </g>
    <defs>
      <clipPath id="clip-peek-up">
        <rect width="98.2891" height="98.2891" fill="white" transform="matrix(0.00223753 0.999997 0.999997 -0.00223753 0.890137 1.11011)" />
      </clipPath>
    </defs>
  </svg>
);

export const PEEK_LEFT_ANIMATION_SVG = (
  <svg width="20" height="20" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip-peek-left)">
      <path
        d="M76.4249 17.9387C94.5732 18.0166 109.222 32.7919 109.144 50.9402C109.066 69.0885 94.291 83.7374 76.1427 83.6594C57.9944 83.5815 43.3455 68.8062 43.4234 50.6579C43.5014 32.5096 58.2766 17.8607 76.4249 17.9387Z"
        className="hide-on-animation-start intro-animation-svg peek-left-animation"
        stroke="#403F5D"
        opacity="0.4"
        strokeWidth="6.18409"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.1075 17.7697C55.2558 17.8477 69.9047 32.623 69.8267 50.7712C69.7488 68.9195 54.9735 83.5684 36.8252 83.4905C18.6769 83.4126 4.02803 68.6373 4.10597 50.489C4.18392 32.3407 18.9592 17.6918 37.1075 17.7697Z"
        className="hide-on-animation-start intro-animation-svg"
        stroke="#403F5D"
        strokeWidth="6.18409"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="98.7857" y1="1.52256" x2="98.3663" y2="99.1832" className="intro-animation-svg" stroke="#403F5D" opacity="0.4" strokeWidth="6.18409" />
    </g>
    <defs>
      <clipPath id="clip-peek-left">
        <rect width="98.2891" height="98.2891" fill="white" transform="matrix(0.999991 0.00429478 0.00429478 -0.999991 0.789368 99.0776)" />
      </clipPath>
    </defs>
  </svg>
);

export const WIPE_DOWN_SVG = (
  <svg width="20" height="20" viewBox="0 0 99 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      clipPath="url(#clip-wipe-down)"
      className="intro-animation-svg wipe-down-animation"
      d="M88.5689 42.5986C88.5689 64.0405 71.1868 81.4226 49.7449 81.4226C28.303 81.4226 10.921 64.0405 10.921 42.5986C10.921 21.1567 28.303 3.77466 49.7449 3.77466C71.1868 3.77466 88.5689 21.1567 88.5689 42.5986Z"
      stroke="#403F5D"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line className="hide-on-animation-start intro-animation-svg" x1="98.5756" y1="66.3605" x2="0.914101" y2="66.3605" stroke="#D9D9D9" strokeWidth="1.86313" />
    <defs>
      <clipPath id="clip-wipe-down">
        <rect width="67.0729" height="98.7461" fill="white" transform="matrix(0 1 1 0 0 0)" />
      </clipPath>
    </defs>
  </svg>
);

export const WIPE_UP_SVG = (
  <svg width="20" height="20" viewBox="0 0 99 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      clipPath="url(#clip-wipe-up)"
      className="intro-animation-svg wipe-up-animation"
      d="M10.1772 24.4741C10.1772 3.03223 27.5593 -14.3499 49.0012 -14.3499C70.4431 -14.3499 87.8252 3.03223 87.8252 24.4741C87.8252 45.916 70.4431 63.2981 49.0012 63.2981C27.5593 63.2981 10.1772 45.916 10.1772 24.4741Z"
      stroke="#403F5D"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line className="hide-on-animation-start intro-animation-svg" x1="0.170532" y1="0.712231" x2="97.8321" y2="0.71224" stroke="#D9D9D9" strokeWidth="1.86313" />
    <defs>
      <clipPath id="clip-wipe-up">
        <rect width="67.0729" height="98.7461" fill="white" transform="matrix(0 -1 -1 0 98.7462 67.0728)" />
      </clipPath>
    </defs>
  </svg>
);

export const WIPE_LEFT_SVG = (
  <svg width="20" height="20" viewBox="0 0 68 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      clipPath="url(#clip-wipe-left)"
      className="intro-animation-svg wipe-left-animation"
      d="M25.3109 88.7322C3.86902 88.7322 -13.5131 71.3501 -13.5131 49.9082C-13.5131 28.4663 3.86902 11.0842 25.3109 11.0842C46.7528 11.0842 64.1349 28.4663 64.1349 49.9082C64.1349 71.3501 46.7528 88.7322 25.3109 88.7322Z"
      stroke="#403F5D"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line className="hide-on-animation-start intro-animation-svg" x1="1.54915" y1="98.739" x2="1.54915" y2="1.07749" stroke="#D9D9D9" strokeWidth="1.86313" />
    <defs>
      <clipPath id="clip-wipe-left">
        <rect width="67.0729" height="98.7461" fill="white" transform="matrix(-1 0 0 1 67.9095 0.16333)" />
      </clipPath>
    </defs>
  </svg>
);

export const WIPE_RIGHT_SVG = (
  <svg width="20" height="20" viewBox="0 0 68 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      clipPath="url(#clip-wipe-right)"
      className="intro-animation-svg wipe-right-animation"
      d="M43.4353 10.3406C64.8772 10.3406 82.2593 27.7227 82.2593 49.1646C82.2593 70.6064 64.8772 87.9885 43.4353 87.9885C21.9934 87.9885 4.61133 70.6064 4.61133 49.1646C4.61133 27.7227 21.9934 10.3406 43.4353 10.3406Z"
      stroke="#403F5D"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line className="hide-on-animation-start intro-animation-svg" x1="67.1971" y1="0.33374" x2="67.1971" y2="97.9953" stroke="#D9D9D9" strokeWidth="1.86313" />
    <defs>
      <clipPath id="clip-wipe-right">
        <rect width="67.0729" height="98.7461" fill="white" transform="matrix(1 0 0 -1 0.83667 98.9094)" />
      </clipPath>
    </defs>
  </svg>
);

export const PAN_DOWN_SVG = (
  <svg width="20" height="20" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M82.1786 37.1144C82.1786 18.966 67.4664 4.25372 49.3179 4.25372C31.1694 4.25372 16.4572 18.966 16.4572 37.1144C16.4572 55.2629 31.1694 69.9751 49.3179 69.9751C67.4664 69.9751 82.1786 55.2629 82.1786 37.1144Z"
      className="hide-on-animation-start intro-animation-svg pan-down-animation"
      stroke="#403F5D"
      opacity="0.4"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82.1786 61.5273C82.1786 43.3788 67.4664 28.6666 49.3179 28.6666C31.1694 28.6666 16.4572 43.3788 16.4572 61.5273C16.4572 79.6757 31.1694 94.3879 49.3179 94.3879C67.4664 94.3879 82.1786 79.6757 82.1786 61.5273Z"
      className="hide-on-animation-start intro-animation-svg"
      fill="white"
      stroke="#403F5D"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PAN_LEFT_SVG = (
  <svg width="20" height="20" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M61.5247 82.6828C79.6731 82.6828 94.3854 67.9706 94.3854 49.8221C94.3854 31.6737 79.6731 16.9614 61.5247 16.9614C43.3762 16.9614 28.664 31.6737 28.664 49.8221C28.664 67.9706 43.3762 82.6828 61.5247 82.6828Z"
      className="hide-on-animation-start intro-animation-svg pan-left-animation"
      stroke="#403F5D"
      opacity="0.4"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.1118 82.6828C55.2602 82.6828 69.9725 67.9706 69.9725 49.8221C69.9725 31.6737 55.2602 16.9614 37.1118 16.9614C18.9633 16.9614 4.2511 31.6737 4.2511 49.8221C4.2511 67.9706 18.9633 82.6828 37.1118 82.6828Z"
      className="hide-on-animation-start intro-animation-svg"
      fill="white"
      stroke="#403F5D"
      strokeWidth="6.18409"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const getSvgFromType = (type: AnimationType, isSelected?: boolean): ReactElement<any> => {
  switch (type) {
    case AnimationType.NONE:
      return NONE_ANIMATION_SVG;
    case AnimationType.BLOCK:
      return BLOCK_ANIMATION_SVG;
    case AnimationType.BOUNCE_IN_DOWN:
      return BOUNCE_IN_DOWN_ANIMATION_SVG;
    case AnimationType.FADE:
      return FADE_ANIMATION_SVG;
    case AnimationType.JELLO:
      return JELLO_ANIMATION_SVG;
    case AnimationType.PAN:
      return PAN_ANIMATION_SVG;
    case AnimationType.POP:
      return POP_ANIMATION_SVG;
    case AnimationType.RISE:
      return RISE_ANIMATION_SVG;
    case AnimationType.ROTATE:
      if (isSelected) {
        return ROTATE_ANIMATION_SVG_SELECTED;
      }
      return ROTATE_ANIMATION_SVG;
    case AnimationType.SLIDE:
      return SLIDE_ANIMATION_SVG;
    case AnimationType.TUMBLE:
      return TUMBLE_ANIMATION_SVG;
    case AnimationType.SHRINK:
      return SHRINK_ANIMATION_SVG;
    case AnimationType.PEEK_DOWN:
      return PEEK_DOWN_ANIMATION_SVG;
    case AnimationType.PEEK_UP:
      return PEEK_UP_ANIMATION_SVG;
    case AnimationType.PEEK_LEFT:
      return PEEK_LEFT_ANIMATION_SVG;
    case AnimationType.PEEK_RIGHT:
      return SLIDE_ANIMATION_SVG;
    case AnimationType.WIPE_DOWN:
      return WIPE_DOWN_SVG;
    case AnimationType.WIPE_UP:
      return WIPE_UP_SVG;
    case AnimationType.WIPE_LEFT:
      return WIPE_LEFT_SVG;
    case AnimationType.WIPE_RIGHT:
      return WIPE_RIGHT_SVG;
    case AnimationType.PAN_DOWN:
      return PAN_DOWN_SVG;
    case AnimationType.PAN_UP:
      return RISE_ANIMATION_SVG;
    case AnimationType.PAN_LEFT:
      return PAN_LEFT_SVG;
    case AnimationType.PAN_RIGHT:
      return PAN_ANIMATION_SVG;
    default:
      return NONE_ANIMATION_SVG;
  }
};

export const getTextFromType = (type: AnimationType): string => {
  switch (type) {
    case AnimationType.NONE:
      return window.i18next.t('pmwjs_none');
    case AnimationType.BLOCK:
      return window.i18next.t('pmwjs_block');
    case AnimationType.BOUNCE_IN_DOWN:
      return window.i18next.t('pmwjs_bounce');
    case AnimationType.FADE:
      return window.i18next.t('pmwjs_fade');
    case AnimationType.JELLO:
      return window.i18next.t('pmwjs_jello');
    case AnimationType.PAN:
      return window.i18next.t('pmwjs_pan');
    case AnimationType.POP:
      return window.i18next.t('pmwjs_pop');
    case AnimationType.RISE:
      return window.i18next.t('pmwjs_rise');
    case AnimationType.ROTATE:
      return window.i18next.t('pmwjs_rotate');
    case AnimationType.SLIDE:
      return window.i18next.t('pmwjs_slide');
    case AnimationType.TUMBLE:
      return window.i18next.t('pmwjs_tumble');
    case AnimationType.SHRINK:
      return window.i18next.t('pmwjs_shrink');
    case AnimationType.PEEK_DOWN:
      return window.i18next.t('pmwjs_peek_down');
    case AnimationType.PEEK_UP:
      return window.i18next.t('pmwjs_peek_up');
    case AnimationType.PEEK_LEFT:
      return window.i18next.t('pmwjs_peek_left');
    case AnimationType.PEEK_RIGHT:
      return window.i18next.t('pmwjs_peek_right');
    case AnimationType.WIPE_DOWN:
      return window.i18next.t('pmwjs_wipe_down');
    case AnimationType.WIPE_UP:
      return window.i18next.t('pmwjs_wipe_up');
    case AnimationType.WIPE_LEFT:
      return window.i18next.t('pmwjs_wipe_left');
    case AnimationType.WIPE_RIGHT:
      return window.i18next.t('pmwjs_wipe_right');
    case AnimationType.PAN_DOWN:
      return window.i18next.t('pmwjs_pan_down');
    case AnimationType.PAN_UP:
      return window.i18next.t('pmwjs_pan_up');
    case AnimationType.PAN_LEFT:
      return window.i18next.t('pmwjs_pan_left');
    case AnimationType.PAN_RIGHT:
      return window.i18next.t('pmwjs_pan_right');
    default:
      return window.i18next.t('pmwjs_none');
  }
};
